import { all, call, put, takeLatest } from "redux-saga/effects";
import store from "store";
import {
  startupRequest,
  loginRequest,
  signupRequest,
  meRequest,
  logoutRequest,
  loginSuccess,
  logout,
} from "../Redux/AuthRedux";

// ---- Startup: restore session from localStorage --------------------
function* onStartup(api, action) {
  const { callback } = action.payload;
  const token = store.get("token");

  if (!token) {
    callback(false);
    return;
  }

  yield call(api.setAuthToken, token);
  const resp = yield call(api.me);

  if (resp.ok) {
    const user = resp.data.user;
    store.set("user", user);
    yield put(loginSuccess({ user, token }));
    callback(true);
  } else {
    store.remove("token");
    store.remove("user");
    yield call(api.removeAuthToken);
    callback(false);
  }
}

// ---- Login ---------------------------------------------------------
function* onLogin(api, action) {
  const { params, callback } = action.payload;
  const resp = yield call(api.login, params);

  if (resp.ok) {
    const { token } = resp.data;
    store.set("token", token);
    yield call(api.setAuthToken, token);

    // Fetch full user data (including credit_balance) from /me
    const meResp = yield call(api.me);
    const user = meResp.ok ? meResp.data.user : resp.data.user;

    store.set("user", user);
    yield put(loginSuccess({ user, token }));
    callback(resp.data, null);
  } else {
    const errText =
      resp.data?.error || resp.data?.errors?.join(", ") || "Invalid credentials";
    callback(null, errText);
  }
}

// ---- Signup --------------------------------------------------------
function* onSignup(api, action) {
  const { params, callback } = action.payload;
  const resp = yield call(api.signup, params);

  if (resp.ok) {
    const { token, user } = resp.data;
    store.set("token", token);
    store.set("user", user);
    yield call(api.setAuthToken, token);
    yield put(loginSuccess({ user, token }));
    callback(resp.data, null);
  } else {
    const errText =
      resp.data?.errors?.join(", ") ||
      resp.data?.error ||
      "There was an error creating your account";
    callback(null, errText);
  }
}

// ---- Me (refresh current user) ------------------------------------
function* onMe(api, action) {
  const { callback } = action.payload;

  // Ensure the auth token is set on the api instance before making the call
  const token = store.get("token");
  if (token) {
    yield call(api.setAuthToken, token);
  }

  const resp = yield call(api.me);

  if (resp.ok) {
    const user = resp.data.user;
    store.set("user", user);
    yield put(loginSuccess({ user, token: token || store.get("token") }));
    callback(resp.data, null);
  } else {
    callback(null, "Failed to fetch user");
  }
}

// ---- Logout --------------------------------------------------------
function* onLogout(api, action) {
  const { callback } = action.payload;
  store.remove("token");
  store.remove("user");
  yield call(api.removeAuthToken);
  yield put(logout());
  callback();
}

// ---- Watcher -------------------------------------------------------
export default function* authSagas(api) {
  yield all([
    takeLatest(startupRequest.type, onStartup, api),
    takeLatest(loginRequest.type, onLogin, api),
    takeLatest(signupRequest.type, onSignup, api),
    takeLatest(meRequest.type, onMe, api),
    takeLatest(logoutRequest.type, onLogout, api),
  ]);
}
